import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import ScanQRCodeBanner from './ScanQRCodeBanner';

const NeedUploadFrontSideImage = ({ isShowBanner = false }) => (
  <>
    <Stack
      aria-label="Need upload front side image"
      mb="40px"
    >
      <Text
        color="tertiary"
        size="md"
      >
        Make sure the check owner’s signature is clearly written on the front of the check.
      </Text>
    </Stack>
    {isShowBanner && (
      <Box mb="40px">
        <ScanQRCodeBanner />
      </Box>
    )}
  </>
);

NeedUploadFrontSideImage.propTypes = {
  isShowBanner: PropTypes.bool
};

export default NeedUploadFrontSideImage;
